import { useCallback } from "react"
import { useMutation, UseMutationConfig } from "react-relay"
import { graphql } from "relay-runtime"
import { useReportAnIssueMutation as useReportAnIssueMutationType } from "@/modules/common/report-issue/services/__generated__/useReportAnIssueMutation.graphql"

const mutation = graphql`
  mutation useReportAnIssueMutation($input: ReportAnIssueInput!) {
    reportAnIssue(input: $input) {
      boolean
    }
  }
`

const useReportAnIssueMutation = () => {
  const [commit, isFlight] = useMutation<useReportAnIssueMutationType>(mutation)

  const commitHandler = useCallback(
    (config: UseMutationConfig<useReportAnIssueMutationType>) => {
      commit(config)
    },
    [commit],
  )

  return [commitHandler, isFlight] as const
}

export { useReportAnIssueMutation }
